import type * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <div className="relative">
      <input
        type={type}
        data-slot="input"
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input h-9 w-full min-w-0 border border-transparent bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className,
        )}
        {...props}
      />
      {/* Top-left corner bracket — top edge fades right, left edge fades down */}
      <span
        className="pointer-events-none absolute top-0 left-0 w-3/4"
        aria-hidden="true"
        style={{
          borderTop: "1px solid",
          borderImage:
            "linear-gradient(to right, var(--accent-dim), transparent) 1",
        }}
      />
      <span
        className="pointer-events-none absolute top-0 left-0 h-3/4 w-px"
        aria-hidden="true"
        style={{
          background:
            "linear-gradient(to bottom, var(--accent-dim), transparent)",
        }}
      />
      {/* Bottom-right corner bracket — bottom edge fades left, right edge fades up */}
      <span
        className="pointer-events-none absolute right-0 bottom-0 w-3/4"
        aria-hidden="true"
        style={{
          borderBottom: "1px solid",
          borderImage:
            "linear-gradient(to left, var(--accent-dim), transparent) 1",
        }}
      />
      <span
        className="pointer-events-none absolute right-0 bottom-0 h-3/4 w-px"
        aria-hidden="true"
        style={{
          background: "linear-gradient(to top, var(--accent-dim), transparent)",
        }}
      />
    </div>
  )
}

export { Input }
